export const SET = "companies/SET";
export const CREATE_SHIPPING_METHOD = "companies/CREATE_SHIPPING_METHOD";
export const FETCH_SHIPPING_METHODS = "companies/FETCH_SHIPPING_METHODS";
export const UPDATE_SHIPPING_METHOD = "companies/UPDATE_SHIPPING_METHOD";
export const DELETE_SHIPPING_METHOD = "companies/DELETE_SHIPPING_METHOD";
export const CREATE_PHYSICAL_ADDRESS = "companies/CREATE_PHYSICAL_ADDRESS";
export const FETCH_PHYSICAL_ADDRESSES = "companies/FETCH_PHYSICAL_ADDRESSES";
export const UPDATE_PHYSICAL_ADDRESS = "companies/UPDATE_PHYSICAL_ADDRESS";
export const DELETE_PHYSICAL_ADDRESS = "companies/DELETE_PHYSICAL_ADDRESS";



// WEBPACK FOOTER //
// ./app/modules/companies/actionTypes.js